// Import react lib
import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// Import style file
import {
    LoginWrapper,
    LoginSection,
    LoginTitle,
    LoginForm,
    LoginFieldContainer,
    LoginLabel,
    LoginInput,
    LoginButton,
} from './style';

// Import global style
import { Loader } from '../../utils/styles/Atoms';

// Import contexts
import { AuthContext } from '../../utils/contexts/AuthContext';

// Import components
import { ErrorMessageStack } from '../../components/Error';

// Import hooks
import { useLogin } from '../../utils/hooks/auth';

// Import texts
import loginTexts from '../../texts/login';
import errorTexts from '../../texts/error';

// Connection page
function Login() {
    // Get a navigator
    const navigate = useNavigate();

    // Get the user and if it exist redirect to home page
    const { user } = useContext(AuthContext);
    useEffect(() => {
        if (user) {
            navigate('/');
        }
    }, [user, navigate]);

    // Get the function to login
    const { login, isLoading, isError } = useLogin();

    // Store a state of the email and password
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const [showPassword, setShowPassword] = useState(false);

    // Handler for submited form
    async function handleSubmit(event) {
        event.preventDefault();

        const isLoginSuccess = await login(email, password);

        // Clear password and data fields
        setEmail('');
        setPassword('');

        // Redirect to home page at login success
        if (isLoginSuccess) {
            navigate('/');
        }
    }

    // Return the loader if the loading is being made
    if (isLoading) {
        return (
            <LoginWrapper>
                <Loader />
            </LoginWrapper>
        );
    }

    return (
        <LoginWrapper>
            <ErrorMessageStack
                errorMessages={[
                    isError && {
                        message: errorTexts.loginError,
                        critical: false,
                    },
                ].filter(Boolean)}
            />
            <LoginSection>
                <LoginTitle>{loginTexts.loginTitle}</LoginTitle>
                <LoginForm onSubmit={handleSubmit}>
                    <LoginFieldContainer>
                        <LoginLabel>{loginTexts.emailLabel}</LoginLabel>
                        <LoginInput
                            type="email"
                            required
                            name="email"
                            value={email}
                            placeholder={loginTexts.emailPlaceholder}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </LoginFieldContainer>
                    <LoginFieldContainer>
                        <LoginLabel>{loginTexts.passwordLabel}</LoginLabel>
                        <LoginInput
                            type={showPassword ? 'text' : 'password'}
                            required
                            name="password"
                            value={password}
                            placeholder={loginTexts.passwordPlaceholder}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </LoginFieldContainer>
                    <LoginFieldContainer>
                        <LoginLabel>{loginTexts.showPasswordLabel}</LoginLabel>
                        <LoginInput
                            type="checkbox"
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                        />
                    </LoginFieldContainer>
                    <LoginButton type="submit">
                        <p style={{ padding: '0', margin: '0' }}>
                            {loginTexts.loginButtonLabel}
                        </p>
                    </LoginButton>
                </LoginForm>
            </LoginSection>
        </LoginWrapper>
    );
}

export default Login;
